import { LanguagesModel } from "../schema/schema";
import { languagesStore, languagesStoreType } from "./store";


export class ConfigKeysAdapter {
  public store: languagesStoreType
  constructor() {
    this.store = languagesStore;
  }

  public setKeysList(languages: LanguagesModel[]) {
    return this.store.setState({ languagesList: languages });
  }

  public setCurrentKey(language: LanguagesModel) {
    return this.store.setState({ currentLanguage: language });
  }

  public filterById(id: string) {
    const prevList = this.store.getState().languagesList;

    return this.store.setState({ languagesList: prevList.filter(item => item.id !== Number(id)) });
  }

  public setTotalCount(count: number) {
    return this.store.setState({ currentCount: count });
  }

  public setLoadingSubmit() {
    return this.store.setState({ loadingSubmit: true });
  }

  public resetLoadingSumbmit() {
    return this.store.setState({ loadingSubmit: false });
  }

}


